import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  ServiceResponseModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CLeanupAdministrationRoutingModule } from './cleanup-administration-routing.module';
import { CleanuupAdministrationComponent } from './component/cleanup-administration.component';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';



@NgModule({
  declarations: [
    CleanuupAdministrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    CLeanupAdministrationRoutingModule,
    ServiceResponseModule,
    CommonTranslationModule,
    CommonUIModule,

    MatTableModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule
]
})
export class CleanupAdministrationModule { }
